import { render, staticRenderFns } from "./t-app-menu-group.vue?vue&type=template&id=232c8878&scoped=true&"
import script from "./t-app-menu-group.vue?vue&type=script&lang=js&"
export * from "./t-app-menu-group.vue?vue&type=script&lang=js&"
import style0 from "./t-app-menu-group.vue?vue&type=style&index=0&id=232c8878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c8878",
  null
  
)

export default component.exports